/**
 * 官网(yeap.cloud) 与控制台(console.yeap.cloud) 登录状态同步。
 *
 * 只写一个「已登录提示」cookie 到 .yeap.cloud：显示名首字 + 过期时间，**不含 token**
 * （token 仍只在控制台 localStorage，避免任何 *.yeap.cloud 页面能读到凭据）。
 * 官网读到它就显示「控制台」入口；登出 / 401 / token 过期时清除。
 */
const COOKIE = 'yc_signed_in';

const parentDomain = () => {
    const h = (typeof window !== 'undefined' && window.location.hostname) || '';
    // 只由客户控制台写；管理后台(spectrum.yeap.cloud)登录/登出不影响官网的客户登录状态
    if (h === 'console.yeap.cloud') return '.yeap.cloud';
    return null;
};

const jwtExp = (token) => {
    try {
        const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
        return typeof payload.exp === 'number' ? payload.exp : null;
    } catch (_) {
        return null;
    }
};

const write = (value, maxAge) => {
    const domain = parentDomain();
    if (!domain) return;
    document.cookie = `${COOKIE}=${value}; Domain=${domain}; Path=/; Max-Age=${maxAge}; Secure; SameSite=Lax`;
};

/** 依据 localStorage 当前 token 设置或清除提示 cookie；可在任何 token 变化后调用。 */
export const syncSignedInHint = () => {
    try {
        const token = localStorage.getItem('auth_token');
        const exp = token ? jwtExp(token) : null;
        const now = Math.floor(Date.now() / 1000);
        if (!token || (exp !== null && exp <= now)) {
            write('', 0);
            return;
        }
        let name = '';
        try {
            const u = JSON.parse(localStorage.getItem('user_info') || 'null');
            name = (u && (u.nickname || u.name || u.username || u.email)) || '';
        } catch (_) { /* ignore */ }
        const value = encodeURIComponent(JSON.stringify({ n: String(name).slice(0, 40), e: exp }));
        write(value, exp !== null ? Math.max(60, exp - now) : 7 * 86400);
    } catch (_) { /* cookie 写不了时官网只是显示登录按钮 */ }
};

export default syncSignedInHint;
